<app-common-header
  [isAdminOrTutor]="role === '1' || role === '2'"
></app-common-header>
<div class="body">
  <div class="mainContent">
    <div class="payments-manager">
      <span class="payments-manager__heading">Payments Manager</span>
      <div class="payments-manager__filterSection">
        <div class="createPayment">
          <button class="createPayment" (click)="openPayment(false)">
            <mat-icon>add_circle_outline</mat-icon>Add New
          </button>
          <p-dialog
            [(visible)]="addPaymentVisible"
            [closeOnEscape]="false"
            [resizable]="false"
            [draggable]="false"
            [header]="selectedPayment ? 'Edit Payment' : 'Create New Payment'"
            *ngIf="addPaymentVisible"
          >
            <!-- <p-overlayPanel #newNote [dismissable]="false"> -->
            <form
              class="createPayment__container"
              [formGroup]="addPaymentForm!"
            >
              <div class="createPayment__container__section">
                <span class="createPayment__container__section--label"
                  >Student</span
                >
                <!-- <input placeholder="Username" class="createPayment__container__section--input"> -->
                <p-autoComplete
                  formControlName="student"
                  [suggestions]="studentSuggestions"
                  class="capitalize"
                  placeholder="Student"
                  (completeMethod)="filterUsers($event)"
                  field="name"
                  [forceSelection]="true"
                  [inputStyleClass]="
                    addPaymentForm!.controls['student'].invalid &&
                    addPaymentError
                      ? 'error-border'
                      : ''
                  "
                >
                  <ng-template let-user pTemplate="item">
                    <span
                      >{{ user.first_name }} {{ user.last_name }}
                      <span class="text-initial">({{ user.email }})</span></span
                    >
                  </ng-template>
                </p-autoComplete>
              </div>
              <div class="createPayment__container__section">
                <span class="createPayment__container__section--label"
                  >Amount</span
                >
                <!-- <input placeholder="Username" class="createPayment__container__section--input"> -->
                <p-inputNumber
                  mode="decimal"
                  inputId="withoutgrouping"
                  [useGrouping]="false"
                  [minFractionDigits]="0"
                  [maxFractionDigits]="2"
                  formControlName="amount"
                  [inputStyleClass]="
                    addPaymentForm!.controls['amount'].invalid &&
                    addPaymentError
                      ? 'error-border'
                      : ''
                  "
                >
                </p-inputNumber>
              </div>
              <div class="createPayment__container__section">
                <span class="createPayment__container__section--label"
                  >Description</span
                >
                <!-- <textarea
                  rows="3"
                  formControlName="description"
                  [ngClass]="{
                    'error-border':
                      addPaymentForm!.controls['description'].invalid &&
                      addPaymentError
                  }"
                  maxlength="20"
                  class="createPayment__container__section--description createPayment__container__section--input"
                ></textarea> -->
                <input
                  pInputText
                  class="createPayment__container__section--description"
                  formControlName="description"
                  maxlength="20"
                />
              </div>
              <div class="createPayment__container__section">
                <span class="createPayment__container__section--label"
                  >Discount</span
                >
                <!-- <input placeholder="Username" class="createPayment__container__section--input"> -->
                <p-inputNumber
                  mode="decimal"
                  inputId="withoutgrouping"
                  [useGrouping]="false"
                  [minFractionDigits]="0"
                  [maxFractionDigits]="2"
                  formControlName="discount"
                  [min]="0"
                >
                </p-inputNumber>
              </div>
              <div class="createPayment__container__section">
                <span class="createPayment__container__section--label"
                  >Due By</span
                >
                <div
                  class="createPayment__container__section--input createPayment__container__section__datepicker"
                  (click)="dueByPicker.open()"
                  [ngClass]="{
                    'error-border':
                      addPaymentForm!.controls['dueBy'].invalid &&
                      addPaymentError
                  }"
                >
                  <input
                    matInput
                    class="createPayment__container__section__datepicker--input"
                    [matDatepicker]="dueByPicker"
                    formControlName="dueBy"
                    readonly
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="dueByPicker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #dueByPicker></mat-datepicker>
                </div>
              </div>
              <div class="createPayment__container__section">
                <span class="createPayment__container__section--label"
                  >Paid For</span
                >
                <div
                  class="createPayment__container__section--input createPayment__container__section__datepicker"
                  (click)="paidForPicker.open()"
                  [ngClass]="{
                    'error-border':
                      addPaymentForm!.controls['paidFor'].invalid &&
                      addPaymentError
                  }"
                >
                  <input
                    matInput
                    class="createPayment__container__section__datepicker--input createPayment__container__section__datepicker--input--absolute"
                    [matDatepicker]="paidForPicker"
                    formControlName="paidFor"
                    readonly
                  />
                  <input
                    class="createPayment__container__section__datepicker--input"
                    readonly
                    (click)="paidForPicker.open()"
                    [value]="getDate(addPaymentForm!.value.paidFor, 'month')"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="paidForPicker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker
                    startView="year"
                    (monthSelected)="selectMonth($event, paidForPicker)"
                    #paidForPicker
                  ></mat-datepicker>
                </div>
              </div>
              <div
                class="createPayment__container__section createPayment__container__section--small"
              >
                <span class="createPayment__container__section--label"
                  >Copy Parent</span
                >
                <p-inputSwitch formControlName="copyParent"></p-inputSwitch>
              </div>
              <div
                class="createPayment__container__section createPayment__container__section--small"
              >
                <span class="createPayment__container__section--label"
                  >Only Parent</span
                >
                <p-inputSwitch formControlName="onlyParent"></p-inputSwitch>
              </div>
              <div
                class="createPayment__container__section createPayment__container__section--installment"
              >
                <div
                  class="createPayment__container__section createPayment__container__section--small"
                >
                  <span class="createPayment__container__section--label"
                    >Installment</span
                  >
                  <p-inputSwitch
                    formControlName="installment"
                    (onChange)="toggleInstallmentValidation($event)"
                  ></p-inputSwitch>
                </div>
                <div
                  class="createPayment__container__section"
                  *ngIf="addPaymentForm!.value.installment"
                >
                  <span class="createPayment__container__section--label"
                    >Recurring Interval Type</span
                  >
                  <mat-select
                    formControlName="intervalType"
                    class="createPayment__container__section--input createPayment__container__section--select"
                    [ngClass]="{
                      'error-border':
                        addPaymentForm!.controls['intervalType'].invalid &&
                        addPaymentError
                    }"
                  >
                    <mat-option value="month">Monthly</mat-option>
                    <mat-option value="year">Yearly</mat-option>
                  </mat-select>
                </div>
                <div
                  class="createPayment__container__section"
                  *ngIf="addPaymentForm!.value.installment"
                >
                  <span class="createPayment__container__section--label"
                    >Recurring Interval</span
                  >
                  <p-inputNumber
                    mode="decimal"
                    inputId="withoutgrouping"
                    [useGrouping]="false"
                    [minFractionDigits]="0"
                    [maxFractionDigits]="0"
                    formControlName="interval"
                    [min]="1"
                    [inputStyleClass]="
                      addPaymentForm!.controls['interval'].invalid &&
                      addPaymentError
                        ? 'error-border'
                        : ''
                    "
                  ></p-inputNumber>
                </div>
                <div
                  class="createPayment__container__section"
                  *ngIf="addPaymentForm!.value.installment"
                >
                  <span class="createPayment__container__section--label"
                    >No of Installments</span
                  >
                  <p-inputNumber
                    mode="decimal"
                    inputId="withoutgrouping"
                    [useGrouping]="false"
                    [minFractionDigits]="0"
                    [maxFractionDigits]="0"
                    formControlName="noOfInstallments"
                    [min]="2"
                    [inputStyleClass]="
                      addPaymentForm!.controls['noOfInstallments'].invalid &&
                      addPaymentError
                        ? 'error-border'
                        : ''
                    "
                  ></p-inputNumber>
                </div>
                <div
                  class="createPayment__container__section"
                  *ngIf="addPaymentForm!.value.installment"
                >
                  <span class="createPayment__container__section--label"
                    >Transaction Charges</span
                  >
                  <!-- <input placeholder="Username" class="createPayment__container__section--input"> -->
                  <p-inputNumber
                    mode="decimal"
                    inputId="withoutgrouping"
                    [useGrouping]="false"
                    [minFractionDigits]="0"
                    [maxFractionDigits]="2"
                    formControlName="transactionCharges"
                    [inputStyleClass]="
                      addPaymentForm!.controls['transactionCharges'].invalid &&
                      addPaymentError
                        ? 'error-border'
                        : ''
                    "
                    [min]="0"
                  >
                  </p-inputNumber>
                </div>
                <p
                  class="createPayment__container__section--big"
                  *ngIf="
                    addPaymentForm!.value.interval &&
                    addPaymentForm!.value.noOfInstallments &&
                    addPaymentForm!.value.intervalType
                  "
                >
                  Total
                  {{ addPaymentForm!.value.noOfInstallments }} installments for
                  every
                  {{ addPaymentForm!.value.interval }}
                  {{ addPaymentForm!.value.intervalType }}(s)
                </p>
              </div>
              <div
                class="createPayment__container__section createPayment__container__section--small createPayment__container__section--first"
              >
                <span class="createPayment__container__section--label"
                  >Already Paid</span
                >
                <p-inputSwitch
                  formControlName="alreadyPaid"
                  (onChange)="toggleValidation($event, 'paymentType')"
                ></p-inputSwitch>
              </div>
              <div
                class="createPayment__container__section"
                *ngIf="addPaymentForm!.value.alreadyPaid"
              >
                <span class="createPayment__container__section--label"
                  >Payment Type</span
                >
                <mat-select
                  class="createPayment__container__section--input createPayment__container__section--select"
                  [ngClass]="{
                    'error-border':
                      addPaymentForm!.controls['paymentType'].invalid &&
                      addPaymentError
                  }"
                  formControlName="paymentType"
                >
                  <mat-option
                    *ngFor="let paymentType of paymentTypes"
                    [value]="paymentType['paymentTypeId']"
                    >{{ paymentType["paymentTypeName"] }}</mat-option
                  >
                </mat-select>
              </div>
              <div class="createPayment__container__footer">
                <button
                  (click)="addPaymentVisible = false"
                  class="createPayment__container__footer--cancel"
                  [disabled]="addPaymentClicked"
                >
                  Cancel
                </button>
                <button
                  class="createPayment__container__footer--add"
                  (click)="addPayment()"
                  [disabled]="addPaymentClicked"
                >
                  {{ selectedPayment ? "Update" : "Add" }}
                </button>
              </div>
            </form>
            <!-- </p-overlayPanel> -->
          </p-dialog>
        </div>
        <div class="payments-manager__filterSection__searchSection">
          <span class="payments-manager__filterSection__searchSection__label"
            >Search</span
          >
          <!-- <div
            class="payments-manager__filterSection__searchSection__inputSection"
          >
            <input
              class="payments-manager__filterSection__searchSection__searchInput"
              placeholder="Student"
              [(ngModel)]="searchStudent"
              (keyup)="getPayments()"
            /><button
              class="payments-manager__filterSection__searchSection__searchButton button"
            >
              <mat-icon>search</mat-icon>
            </button>
          </div> -->
          <p-autoComplete
            [(ngModel)]="searchStudent"
            [suggestions]="studentSuggestions"
            class="capitalize"
            placeholder="Student"
            (completeMethod)="filterUsers($event)"
            field="name"
            [forceSelection]="true"
            (onSelect)="getPayments(0)"
          >
            <ng-template let-student pTemplate="item">
              <span
                >{{ student.first_name }} {{ student.last_name }}
                <span class="text-initial">({{ student.email }})</span></span
              >
            </ng-template>
          </p-autoComplete>
        </div>
        <div class="payments-manager__filterSection__selectNote">
          <span class="payments-manager__filterSection__selectNote__label"
            >Status</span
          >
          <mat-select
            class="payments-manager__filterSection__selectNote__select"
            [(ngModel)]="statusFilter"
            (selectionChange)="getPayments(0)"
          >
            <mat-option
              *ngFor="let status of statusOptions"
              [value]="status.value"
              >{{ status.label }}</mat-option
            >
          </mat-select>
        </div>
        <div class="payments-manager__filterSection__selectNote">
          <span class="payments-manager__filterSection__selectNote__label"
            >Sort</span
          >
          <mat-select
            class="payments-manager__filterSection__selectNote__select"
            [(ngModel)]="orderByFilter"
            (selectionChange)="getPayments(0)"
          >
            <mat-option value="asec">Oldest First</mat-option>
            <mat-option value="desc">Latest First</mat-option>
          </mat-select>
        </div>
      </div>
      <div class="payments-manager__table-container">
        <table
          mat-table
          [dataSource]="payments"
          class="payments-manager__table"
          matSort
        >
          <!-- <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let payment" class="capitalize">
              <mat-checkbox
                [checked]="selectedPayments.indexOf(payment.invoiceId) >= 0"
                (change)="selectNote(payment.invoiceId)"
              ></mat-checkbox>
            </td>
          </ng-container> -->
          <ng-container matColumnDef="studentName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Student</th>
            <td
              mat-cell
              *matCellDef="let payment"
              class="capitalize"
              (click)="
                selectedPayment = payment;
                payment.status === '1' ||
                payment.status === '2' ||
                payment.status === '4' ||
                payment.status === '7' ||
                payment.status === '9'
                  ? openPayment(true)
                  : false
              "
              [ngClass]="{
                'payments-manager__table__student-name':
                  payment.status === '1' ||
                  payment.status === '2' ||
                  payment.status === '4' ||
                  payment.status === '7' ||
                  payment.status === '9'
              }"
            >
              {{ payment.studentName }}
            </td>
          </ng-container>
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Description
            </th>
            <td mat-cell *matCellDef="let payment" class="capitalize">
              {{ payment.description }}
            </td>
          </ng-container>
          <ng-container matColumnDef="dueBy">
            <th mat-header-cell *matHeaderCellDef>Due By</th>
            <td mat-cell *matCellDef="let payment" class="capitalize">
              {{ payment.dueDate | date: "MM-dd-YYYY" }}
            </td>
          </ng-container>
          <ng-container matColumnDef="installment">
            <th mat-header-cell *matHeaderCellDef>Installment</th>
            <td mat-cell *matCellDef="let payment" class="capitalize">
              <p-inputSwitch
                [(ngModel)]="payment.allowInstallment"
                [disabled]="true"
              ></p-inputSwitch>
            </td>
          </ng-container>
          <!-- <ng-container matColumnDef="intervalType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Interval Type
            </th>
            <td mat-cell *matCellDef="let payment" class="capitalize">
              {{
                payment.allowInstallment ? payment.recurringInterval + "ly" : ""
              }}
            </td>
          </ng-container>
          <ng-container matColumnDef="interval">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Interval</th>
            <td mat-cell *matCellDef="let payment" class="capitalize">
              {{ payment.recurringIntervalCount }}
            </td>
          </ng-container> -->

          <ng-container matColumnDef="noOfInstallments">
            <th mat-header-cell *matHeaderCellDef>No of Installments</th>
            <td mat-cell *matCellDef="let payment" class="capitalize">
              {{ payment.iterations }}
            </td>
          </ng-container>
          <!-- <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
            <td mat-cell *matCellDef="let payment" class="capitalize">
              {{ payment.amount }}
            </td>
          </ng-container>
          <ng-container matColumnDef="discount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Discount</th>
            <td mat-cell *matCellDef="let payment" class="capitalize">
              {{ payment.discount }}
            </td>
          </ng-container> -->
          <ng-container matColumnDef="finalAmount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
            <td mat-cell *matCellDef="let payment" class="capitalize">
              {{ payment.finalAmount }}
            </td>
          </ng-container>
          <ng-container matColumnDef="paidAmount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Paid Amount
            </th>
            <td mat-cell *matCellDef="let payment" class="capitalize">
              {{ payment.paidAmount }}
            </td>
          </ng-container>
          <ng-container matColumnDef="dueAmount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Due Amount
            </th>
            <td mat-cell *matCellDef="let payment" class="capitalize">
              {{ payment.dueAmount }}
            </td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let payment" class="capitalize">
              <span
                class="payments-manager__table__status__text"
                [ngClass]="
                  payment.status === '1' ||
                  payment.status === '2' ||
                  payment.status === '6' ||
                  payment.status === '7' ||
                  payment.status === '10' ||
                  payment.status === '16' ||
                  payment.status === '17'
                    ? 'payments-manager__table__status__text__pending'
                    : payment.status === '4' ||
                        payment.status === '9' ||
                        payment.status === '11' ||
                        payment.status === '15'
                      ? 'payments-manager__table__status__text__failed'
                      : payment.status === '3' ||
                          payment.status === '5' ||
                          payment.status === '8' ||
                          payment.status === '12'
                        ? 'payments-manager__table__status__text__success'
                        : ''
                "
                >{{ getStatus(payment.status) }}</span
              >
            </td>
          </ng-container>
          <ng-container matColumnDef="paymentType">
            <th mat-header-cell *matHeaderCellDef>Payment Type</th>
            <td mat-cell *matCellDef="let payment" class="capitalize">
              {{ payment.paymentTypeName }}
            </td>
          </ng-container>
          <ng-container matColumnDef="details">
            <th mat-header-cell *matHeaderCellDef></th>
            <!-- <td mat-cell *matCellDef="let payment" class="capitalize">
              <button
                class="payments-manager__table__details"
                [ngStyle]="{
                  margin: payment?.paymentDetails
                    ?.canShowUpdatePaymentMethodButton
                    ? '5px 0px'
                    : '0px 0px'
                }"
                (click)="selectedPayment = payment; showPaymentDetails = true"
                *ngIf="
                  payment.status !== '1' &&
                  payment.status !== '2' &&
                  payment.status !== '5' &&
                  payment.status !== '7'
                "
              >
                Details
              </button>
              <button
                class="payments-manager__table__details"
                (click)="openDueModal(payment)"
                *ngIf="
                  payment.status === '1' ||
                  payment.status === '2' ||
                  payment.status === '4' ||
                  payment.status === '7'
                "
              >
                Generate
              </button>
              <button
                class="payments-manager__table__details"
                style="margin: 0px 0px 5px 0px"
                (click)="updatePaymentMethod(payment)"
                *ngIf="
                  payment?.paymentDetails?.canShowUpdatePaymentMethodButton
                "
              >
                Update Payment Method
              </button>
              <button>
                <mat-icon class="view-icon">visibility</mat-icon>
              </button>
            </td> -->
            <td
              mat-cell
              *matCellDef="let payment"
              class="capitalize payments-manager__table__action-icons"
            >
              <button
                mat-icon-button
                matTooltip="View Details"
                (click)="selectedPayment = payment; showPaymentDetails = true"
                *ngIf="
                  payment.status !== '1' &&
                  payment.status !== '2' &&
                  payment.status !== '5' &&
                  payment.status !== '7'
                "
              >
                <mat-icon class="payments-manager__table__details-icon"
                  >visibility</mat-icon
                >
              </button>

              <button
                mat-icon-button
                matTooltip="Create Invoice"
                (click)="openDueModal(payment)"
                *ngIf="
                  payment.status === '1' ||
                  payment.status === '2' ||
                  payment.status === '4' ||
                  payment.status === '7'
                "
              >
                <mat-icon class="payments-manager__table__details-icon"
                  >receipt_long</mat-icon
                >
              </button>
              <button
                mat-icon-button
                matTooltip="Update Payment Method"
                (click)="updatePaymentMethod(payment)"
                *ngIf="
                  payment?.paymentDetails?.canShowUpdatePaymentMethodButton
                "
              >
                <mat-icon class="payments-manager__table__details-icon"
                  >edit_square</mat-icon
                >
              </button>
              <button
                mat-icon-button
                matTooltip="Cancel Subscription"
                (click)="openCancelSubscriptionModal(payment)"
                *ngIf="payment?.canCancelSubscription"
              >
                <mat-icon class="payments-manager__table__details-icon"
                  >cancel</mat-icon
                >
              </button>
              <button
                mat-icon-button
                matTooltip="Delete Invoice"
                (click)="openDeleteInvoiceModal(payment)"
                *ngIf="payment?.canDeleteInvoice"
              >
                <mat-icon class="payments-manager__table__details-icon"
                  >delete</mat-icon
                >
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
          <tr
            mat-row
            *matRowDef="let myRowData; columns: columnsToDisplay"
          ></tr>
        </table>
      </div>
      <mat-paginator
        [pageSize]="15"
        showFirstLastButtons
        #paginator
        [length]="totalPayments"
        (page)="getPageData($event)"
        [pageIndex]="pageIndex"
      ></mat-paginator>
      <p-dialog
        *ngIf="showPaymentDetails"
        [(visible)]="showPaymentDetails"
        [modal]="true"
        header="Payment Details"
        class="payments-manager__dialog"
      >
        <div class="payments-manager__dialog__body">
          <div class="payments-manager__dialog__body__section">
            <span class="payments-manager__dialog__body__section__bold"
              >Payment Plan:
            </span>
            <span class="payments-manager__dialog__body__section__normal">{{
              selectedPayment.paymentDetails.isInstallmentPayment
                ? "Installment"
                : "Full Payment"
            }}</span>
          </div>
          <div class="payments-manager__dialog__body__section">
            <span class="payments-manager__dialog__body__section__bold"
              >Txn ID:
            </span>
            <span class="payments-manager__dialog__body__section__normal">{{
              selectedPayment.invoiceId
            }}</span>
          </div>
          <div class="payments-manager__dialog__body__section">
            <span class="payments-manager__dialog__body__section__bold"
              >Status:
            </span>

            <span
              class="payments-manager__table__status__text"
              [ngClass]="
                selectedPayment.status === '1' ||
                selectedPayment.status === '2' ||
                selectedPayment.status === '6' ||
                selectedPayment.status === '7' ||
                selectedPayment.status === '10' ||
                selectedPayment.status === '16' ||
                selectedPayment.status === '17'
                  ? 'payments-manager__table__status__text__pending'
                  : selectedPayment.status === '4' ||
                      selectedPayment.status === '9' ||
                      selectedPayment.status === '11' ||
                      selectedPayment.status === '15'
                    ? 'payments-manager__table__status__text__failed'
                    : selectedPayment.status === '3' ||
                        selectedPayment.status === '5' ||
                        selectedPayment.status === '8'
                      ? 'payments-manager__table__status__text__success'
                      : ''
              "
              >{{ getStatus(selectedPayment.status) }}</span
            >
            <button
              mat-icon-button
              matTooltip="Checkout Invoice"
              (click)="
                checkoutInvoice(
                  selectedPayment.paymentDetails?.successfulTransactions[0]
                )
              "
              *ngIf="
                selectedPayment.paymentDetails?.successfulTransactions?.[0]
                  ?.canDownloadInvoice && selectedPayment?.status === '3'
              "
            >
              <mat-icon class="payments-manager__table__details-icon"
                >download_for_offline</mat-icon
              >
            </button>
          </div>
          <div
            class="payments-manager__dialog__body__section"
            *ngIf="selectedPayment.paymentDetails.isInstallmentPayment"
          >
            <span class="payments-manager__dialog__body__section__bold"
              >Number of Payments done:
            </span>
            <span class="payments-manager__dialog__body__section__normal"
              >{{
                selectedPayment.paymentDetails.successfulTransactions.length
              }}
              out of {{ selectedPayment.iterations }}</span
            >
          </div>
          <div class="payments-manager__dialog__body__section">
            <span class="payments-manager__dialog__body__section__bold"
              >Amount:
            </span>
            <span class="payments-manager__dialog__body__section__normal"
              >${{ selectedPayment.amount }}</span
            >
          </div>
          <div class="payments-manager__dialog__body__section">
            <span class="payments-manager__dialog__body__section__bold"
              >Discount:
            </span>
            <span class="payments-manager__dialog__body__section__normal"
              >${{ selectedPayment.discount }}</span
            >
          </div>
          <div class="payments-manager__dialog__body__section">
            <span class="payments-manager__dialog__body__section__bold"
              >Final Amount:</span
            >
            <span class="payments-manager__dialog__body__section__normal"
              >${{ selectedPayment.finalAmount }}</span
            >
          </div>
          <div class="payments-manager__dialog__body__section">
            <span class="payments-manager__dialog__body__section__bold"
              >Paid Amount:</span
            >
            <span class="payments-manager__dialog__body__section__normal"
              >${{ selectedPayment.paidAmount }}</span
            >
          </div>
          <div class="payments-manager__dialog__body__section">
            <span class="payments-manager__dialog__body__section__bold"
              >Due Amount:</span
            >
            <span class="payments-manager__dialog__body__section__normal"
              >${{ selectedPayment.dueAmount }}</span
            >
          </div>
          <div
            class="payments-manager__dialog__body__section"
            *ngIf="selectedPayment.paymentDetails.isInstallmentPayment"
          >
            <span class="payments-manager__dialog__body__section__bold"
              >Transactions Charges Received:
            </span>
            <span class="payments-manager__dialog__body__section__normal"
              >${{
                selectedPayment.paymentDetails.successfulTransactions.length *
                  selectedPayment.transactionCharges
              }}</span
            >
          </div>
          <div class="payments-manager__dialog__body__section">
            <span class="payments-manager__dialog__body__section__bold"
              >Due By:</span
            >
            <span class="payments-manager__dialog__body__section__normal">{{
              selectedPayment.dueBy
            }}</span>
          </div>
          <div
            class="payments-manager__dialog__body__section"
            *ngIf="!selectedPayment.paymentDetails.isInstallmentPayment"
          >
            <span class="payments-manager__dialog__body__section__bold"
              >Paid On:</span
            >
            <span class="payments-manager__dialog__body__section__normal">{{
              selectedPayment.paymentDetails.transactions?.length > 0
                ? selectedPayment.paymentDetails.transactions[0]?.date
                : ""
            }}</span>
          </div>
          <ng-container
            *ngIf="selectedPayment.paymentDetails.isInstallmentPayment"
          >
            <div class="payments-manager__dialog__body__section">
              <span class="payments-manager__dialog__body__section__bold"
                >Last Installment On:</span
              >
              <span class="payments-manager__dialog__body__section__normal">{{
                selectedPayment.paymentDetails.successfulTransactions.length > 0
                  ? selectedPayment.paymentDetails.successfulTransactions[
                      selectedPayment.paymentDetails.successfulTransactions
                        .length - 1
                    ].date
                  : ""
              }}</span>
            </div>
            <div
              class="payments-manager__dialog__body__section"
              *ngIf="
                selectedPayment.paymentDetails.successfulTransactions.length <
                selectedPayment.iterations
              "
            >
              <span class="payments-manager__dialog__body__section__bold"
                >Next Installment:</span
              >
              <span class="payments-manager__dialog__body__section__normal">{{
                getNextInstallment()
              }}</span>
            </div>
            <div
              *ngFor="
                let transaction of selectedPayment.paymentDetails.transactions;
                let transactionIndex = index
              "
              class="payments-manager__dialog__body__transaction"
            >
              <span>{{ transactionIndex + 1 }}.</span>
              <span>{{
                transaction.paymentStatus === 15
                  ? "Refund"
                  : "Installment " + (transactionIndex + 1)
              }}</span>
              <span
                *ngIf="
                  transaction.paymentStatus !== 4 &&
                    transaction.paymentStatus !== 9;
                  else failedTransaction
                "
                >${{
                  (transaction.amountReceived < 0
                    ? -transaction.amountReceived -
                      (transaction.paymentStatus === 15 &&
                      selectedPayment.transactionCharges > 0
                        ? selectedPayment.transactionCharges
                        : 0)
                    : transaction.amountReceived
                  ).toFixed(2)
                }}
                {{
                  transaction.paymentStatus === 15 &&
                  transaction.amountReceived < 0
                    ? selectedPayment.transactionCharges > 0
                      ? " + $" + selectedPayment.transactionCharges
                      : ""
                    : transaction.transactionCharges
                      ? " + $" + transaction.transactionCharges
                      : ""
                }}
              </span>
              <ng-template #failedTransaction><span></span></ng-template>
              <span>{{ transaction.date }} </span>
              <span>Stripe Id: {{ transaction.sessionId }} </span>
              <span
                class="payments-manager__table__status__text"
                [ngClass]="
                  transaction.paymentStatus === 1 ||
                  transaction.paymentStatus === 2 ||
                  transaction.paymentStatus === 6 ||
                  transaction.paymentStatus === 7 ||
                  transaction.paymentStatus === 10
                    ? 'payments-manager__table__status__text__pending'
                    : transaction.paymentStatus === 4 ||
                        transaction.paymentStatus === 9 ||
                        transaction.paymentStatus === 11 ||
                        transaction.paymentStatus === 15
                      ? 'payments-manager__table__status__text__failed'
                      : transaction.paymentStatus === 3 ||
                          transaction.paymentStatus === 5 ||
                          transaction.paymentStatus === 8
                        ? 'payments-manager__table__status__text__success'
                        : ''
                "
                >{{ getStatus(transaction.paymentStatus.toString()) }}</span
              >
              <button
                mat-icon-button
                matTooltip="Download Invoice"
                (click)="downloadInvoice(transaction)"
                *ngIf="transaction?.canDownloadInvoice"
              >
                <mat-icon class="payments-manager__table__details-icon"
                  >download_for_offline</mat-icon
                >
              </button>
            </div>
          </ng-container>
        </div>
      </p-dialog>
      <!-- Dialog for generating payment link -->
      <p-dialog
        *ngIf="showGetPayment"
        [class]="isMobile ? 'payNowDialog-mobile' : 'payNowDialog'"
        header="Pay Now"
        [(visible)]="showGetPayment"
        [modal]="true"
        [draggable]="false"
        contentStyleClass="payNowDialog-content"
      >
        <div
          class="flex gap-2 items-center"
          [ngClass]="{ grid: isMobile }"
          *ngIf="selectedPayment?.allowInstallment"
        >
          <span class="payNowDialog-paymentType-text"
            >Select a payment type:</span
          >
          <div
            class="card flex justify-content-center"
            [ngClass]="{ 'w-max': isMobile }"
          >
            <p-selectButton
              class="payNowDialog-select"
              [ngClass]="{ 'payNowDialog-select-mobile': isMobile }"
              [options]="paymentOptions"
              [(ngModel)]="isPaymentOrInstallment"
              (ngModelChange)="termCheck1 = false"
              optionLabel="label"
              optionValue="value"
            ></p-selectButton>
          </div>
        </div>

        <div class="payNowDialog-invoice pt-2" id="generate-payment">
          <div
            *ngIf="isPaymentOrInstallment >= 0"
            class="payNowDialog-invoice-holder mt-2"
          >
            <div
              class="payNowDialog-invoice-header flex justify-between items-center"
              [ngClass]="{ 'py-1 px-4': isMobile, 'py-4 px-8': !isMobile }"
            >
              <span>INVOICE</span>
            </div>
            <div
              *ngIf="isPaymentOrInstallment === 0"
              class="flex flex-col gap-8 py-4 px-2"
            >
              <div>
                <div
                  class="payNowDialog-invoice-item payNowDialog-invoice-item-name"
                >
                  Due Amount
                </div>
                <div
                  class="payNowDialog-invoice-item payNowDialog-invoice-item-value"
                >
                  ${{ getAmountByInstallment(false) }}
                </div>
              </div>
              <div class="block">
                <div
                  class="payNowDialog-invoice-item payNowDialog-invoice-item-name"
                >
                  Description
                </div>
                <div
                  class="payNowDialog-invoice-item payNowDialog-invoice-item-value"
                  [ngStyle]="{ 'font-size': isMobile ? '14px' : 'unset' }"
                >
                  {{ selectedPayment!.description }}
                </div>
              </div>
              <div class="block">
                <div
                  class="payNowDialog-invoice-item payNowDialog-invoice-item-name"
                >
                  Due Date
                </div>
                <div
                  class="payNowDialog-invoice-item payNowDialog-invoice-item-value"
                >
                  {{ selectedPayment!.dueDate }}
                </div>
              </div>
              <div
                class="flex gap-2 px-2 text-justify items-baseline"
                [ngStyle]="{ 'font-size': isMobile ? '13px' : 'small' }"
              >
                <span
                  [ngStyle]="{
                    position: isMobile ? 'relative' : 'static',
                    top: isMobile ? '4px' : '0px'
                  }"
                  >*</span
                >
                <span
                  >I agree to pay the above mentioned amount in full and give a
                  permission to Ravi's Academy to charge on the due date.</span
                >
              </div>
              <div class="flex justify-center gap-2 px-2">
                <mat-checkbox
                  class="payNow-installment-checkbox"
                  [(ngModel)]="termCheck1"
                ></mat-checkbox>
                <!-- <span>*</span> -->
                <div
                  class="flex items-center"
                  [ngStyle]="{ 'font-size': isMobile ? '13px' : 'normal' }"
                >
                  <span>I Agree to pay</span>
                </div>
              </div>
              <div class="flex justify-center pb-4">
                <span
                  class="payNowDialog-invoice-item-payNowBtn flex self-center"
                  [ngClass]="{
                    'payNowDialog-invoice-item-payNowBtn-mobile': isMobile,
                    'payNowDialog-invoice-item-payNowBtn-invalid': !termCheck1
                  }"
                  (click)="installmentPay()"
                >
                  Generate Link
                </span>
              </div>
              <div
                *ngIf="fullPaymentLink !== ''"
                class="border border-secondary rounded p-2 paymentLink"
              >
                <span class="paymentLink--text">{{ fullPaymentLink }}</span>
                <mat-icon
                  class="paymentLink--icon"
                  [cdkCopyToClipboard]="fullPaymentLink"
                  (cdkCopyToClipboardCopied)="linkCopied($event)"
                  >content_copy</mat-icon
                >
              </div>
            </div>
            <div
              *ngIf="isPaymentOrInstallment === 1"
              class="flex flex-col py-4 px-2"
              style="gap: 1rem"
            >
              <div *ngIf="!isMobile">
                <b>Total Amount to be paid </b> &nbsp; : ${{
                  selectedPayment!.transactionCharges === null ||
                  selectedPayment!.transactionCharges === 0
                    ? getAmountByInstallment(true)
                    : getTransactionCharge(true) +
                      " " +
                      " (Including transaction charges)"
                }}
              </div>
              <div *ngIf="isMobile" class="block">
                <div class="flex justify-center font-medium">
                  Total Amount to be paid
                </div>
                <div
                  *ngIf="selectedPayment!.transactionCharges === 0"
                  class="flex justify-center font-bold"
                  style="font-size: 15px"
                >
                  ${{ getAmountByInstallment(true) }}
                </div>
                <div
                  *ngIf="selectedPayment!.transactionCharges > 0"
                  class="flex justify-center font-bold"
                  style="font-size: 15px"
                >
                  {{ "$" + getTransactionCharge(true) }}
                </div>
                <div
                  *ngIf="selectedPayment!.transactionCharges > 0"
                  class="flex justify-center font-bold"
                  style="font-size: 15px"
                >
                  (Including transaction charges)
                </div>
              </div>
              <div class="flex gap-4" [ngClass]="{ grid: isMobile }">
                <div *ngIf="!isMobile" class="flex gap-4 items-center">
                  <span
                    class="payNowDialog-installment-text"
                    [ngClass]="{
                      'payNowDialog-installment-text-mobile': isMobile
                    }"
                    ><b>Total number of installments</b> : &nbsp;
                    {{ selectedPayment!.iterations }}
                  </span>
                </div>
                <div *ngIf="isMobile" class="block">
                  <div class="flex justify-center text-sm">
                    Total number of Installments
                  </div>
                  <div class="flex justify-center text-md font-bold">
                    {{ selectedPayment!.iterations }}
                  </div>
                </div>
              </div>
              <div class="flex justify-center gap-8">
                <div style="max-height: 9.5rem; overflow: auto; display: grid">
                  <div
                    class="flex p-2 font-bold text-sm"
                    style="
                      border: 1px solid black;
                      background: #fff;
                      position: sticky;
                      top: 0;
                    "
                  >
                    <span style="min-width: 7rem">Installments</span>
                    <span style="min-width: 84px">Date</span>
                    <span style="min-width: 84px">Amount</span>
                    <span
                      *ngIf="selectedPayment!.transactionCharges"
                      style="width: 100px; word-wrap: break-word"
                      >Transaction Fee</span
                    >
                    <span
                      *ngIf="selectedPayment!.transactionCharges"
                      style="min-width: 84px"
                      >Total</span
                    >
                  </div>
                  <div
                    *ngFor="
                      let installmentDate of installmentDates;
                      let installmentIndex = index
                    "
                    class="flex p-2"
                    style="
                      font-size: 14px;
                      min-width: 15rem;
                      border: 1px solid black;
                      border-top: 0px solid transparent;
                    "
                  >
                    <!-- <div class="flex"> -->
                    <div style="min-width: 7rem">
                      {{ "Installment " + (installmentIndex + 1) }}
                    </div>
                    <!-- <div>:</div> -->
                    <!-- </div> -->
                    <!-- <div class="flex gap-4"> -->
                    <div style="min-width: 84px">{{ installmentDate }}</div>
                    <div style="min-width: 84px">
                      ${{ getAmountByInstallment(false) }}
                    </div>
                    <div
                      *ngIf="selectedPayment!.transactionCharges"
                      style="min-width: 100px"
                    >
                      ${{ selectedPayment!.transactionCharges }}
                    </div>
                    <div
                      *ngIf="selectedPayment!.transactionCharges"
                      style="min-width: 84px"
                    >
                      ${{
                        (
                          (selectedPayment!.amount -
                            selectedPayment!.discount) /
                            selectedPayment!.iterations +
                          selectedPayment!.transactionCharges
                        ).toFixed(2)
                      }}
                    </div>
                    <!-- </div> -->
                  </div>
                </div>
              </div>
              <div
                *ngIf="selectedPayment!.transactionCharges > 0"
                class="flex gap-2 px-2 text-justify items-baseline"
                [ngStyle]="{ 'font-size': isMobile ? '13px' : 'small' }"
              >
                <span
                  [ngStyle]="{
                    position: isMobile ? 'relative' : 'static',
                    top: isMobile ? '4px' : '0px'
                  }"
                  >*</span
                >
                <span
                  >For the installment option, an additional service charge
                  mentioned above will be applied to every installment.</span
                >
              </div>
              <div
                class="flex gap-2 px-2 text-justify items-baseline"
                [ngStyle]="{ 'font-size': isMobile ? '13px' : 'small' }"
              >
                <span
                  [ngStyle]="{
                    position: isMobile ? 'relative' : 'static',
                    top: isMobile ? '4px' : '0px'
                  }"
                  >*</span
                >
                <span
                  >I agree to pay the above mentioned amount in installments and
                  give a permission to Ravi's Academy to charge automatically on
                  the due date for each installment.</span
                >
              </div>
              <div class="flex gap-2 px-2">
                <mat-checkbox
                  class="payNow-installment-checkbox"
                  [(ngModel)]="termCheck1"
                ></mat-checkbox>
                <!-- <span>*</span> -->
                <div
                  class="flex items-center"
                  [ngStyle]="{ 'font-size': isMobile ? '13px' : 'normal' }"
                >
                  <span>I Agree to pay in Installments.</span>
                  <!-- <span
              class="payNowDialog-installment-terms"
              (click)="showTAndCModal = true"
              >terms & conditions</span
            > -->
                </div>
              </div>
              <span
                class="payNowDialog-invoice-item-payNowBtn flex self-center"
                [ngClass]="{
                  'payNowDialog-invoice-item-payNowBtn-invalid':
                    !termCheck1 && isPaymentOrInstallment === 1,
                  'payNowDialog-invoice-item-payNowBtn-mobile': isMobile
                }"
                (click)="installmentPay()"
              >
                Generate Link
              </span>
              <div
                *ngIf="subscriptionLink"
                class="border border-secondary rounded p-2 paymentLink"
              >
                <span class="paymentLink--text">{{ subscriptionLink }}</span>
                <mat-icon
                  class="paymentLink--icon"
                  [cdkCopyToClipboard]="subscriptionLink"
                  (cdkCopyToClipboardCopied)="linkCopied($event)"
                  >content_copy</mat-icon
                >
              </div>
            </div>
          </div>
        </div>
      </p-dialog>
      <!-- Dialog for cancelling a subscription -->
      <p-dialog
        *ngIf="showCancelSubscriptionDialog"
        [(visible)]="showCancelSubscriptionDialog"
        [modal]="true"
        [closeOnEscape]="false"
        [draggable]="false"
        [resizable]="false"
        header="Cancel Subscription"
        class="payments-manager__cancelSubscriptionDialog"
        (onHide)="closeCancelSubscriptionModal()"
      >
        <div class="payments-manager__cancelSubscriptionDialog__body">
          <p
            class="payments-manager__cancelSubscriptionDialog__body__description"
          >
            This subscription will be cancelled immediately.
          </p>
          <span class="payments-manager__cancelSubscriptionDialog__body__label"
            >Refund</span
          >
          <mat-radio-group
            [(ngModel)]="cancelSubscriptionRefundOption"
            class="payments-manager__cancelSubscriptionDialog__body__options"
          >
            <mat-radio-button value="NO_REFUND">No Refund</mat-radio-button>
            <mat-radio-button value="LAST_PAID_AMOUNT">
              Last Payment
              <span *ngIf="getLastPaymentAmount()"
                >(${{ getLastPaymentAmount() }})</span
              >
            </mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="payments-manager__cancelSubscriptionDialog__footer">
          <button
            class="payments-manager__cancelSubscriptionDialog__footer--cancel"
            (click)="closeCancelSubscriptionModal()"
            [disabled]="cancelSubscriptionClicked"
          >
            Don't cancel
          </button>
          <button
            class="payments-manager__cancelSubscriptionDialog__footer--confirm"
            (click)="confirmCancelSubscription()"
            [disabled]="cancelSubscriptionClicked"
          >
            Cancel Subscription
          </button>
        </div>
      </p-dialog>
      <!-- Dialog for deleting an invoice -->
      <p-dialog
        *ngIf="showDeleteInvoiceDialog"
        [(visible)]="showDeleteInvoiceDialog"
        [modal]="true"
        [closeOnEscape]="false"
        [draggable]="false"
        [resizable]="false"
        header="Delete Invoice"
        class="payments-manager__deleteInvoiceDialog"
        (onHide)="closeDeleteInvoiceModal()"
      >
        <div class="payments-manager__deleteInvoiceDialog__body">
          <p class="payments-manager__deleteInvoiceDialog__body__description">
            Are you sure you want to delete this invoice? This action cannot be
            undone.
          </p>
        </div>
        <div class="payments-manager__deleteInvoiceDialog__footer">
          <button
            class="payments-manager__deleteInvoiceDialog__footer--cancel"
            (click)="closeDeleteInvoiceModal()"
            [disabled]="deleteInvoiceClicked"
          >
            Cancel
          </button>
          <button
            class="payments-manager__deleteInvoiceDialog__footer--confirm"
            (click)="confirmDeleteInvoice()"
            [disabled]="deleteInvoiceClicked"
          >
            Delete Invoice
          </button>
        </div>
      </p-dialog>
      <!-- Loader -->
      <p-dialog
        [(visible)]="showLoader"
        [modal]="true"
        [blockScroll]="true"
        [closeOnEscape]="false"
        [closable]="false"
        [showHeader]="false"
        appendTo="body"
        contentStyleClass="loader flex justify-center"
        styleClass="loaderContainer"
      >
        <!-- <mat-spinner>Please wait</mat-spinner> -->
        <p-progressSpinner strokeWidth="4"></p-progressSpinner>
      </p-dialog>
    </div>
  </div>
  <app-footer></app-footer>
</div>
